import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReportList from './ReportList';
import './EmptyList.css';
import './ReportList.css';
import './Filters.css';

import * as reportBuilderActions from '../../actions/report-builder-actions';
import * as reportBuilderSelectors from '../../reducers/report-builder-reducer';
import * as userSelectors from '../../reducers/user-reducer';

const mapStateToProps = state => ({
  error: reportBuilderSelectors.selectError(state),
  reports: reportBuilderSelectors.selectMyReports(state),
  loading: reportBuilderSelectors.selectLoading(state),
  userId: userSelectors.selectUserId(state)
});

const mapDispatchToProps = dispatch => ({
  reportBuilderActions: bindActionCreators(reportBuilderActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);
